<template>
  <div>
    <el-dialog
      top="2vh"
      id="tacticsFreezeDialog"
      center
      :title="`${
        tacticsFreezePageQuery && tacticsFreezePageQuery.userName
          ? tacticsFreezePageQuery.userName + ' 冻结、暂扣积分'
          : '冻结、暂扣积分记录'
      }`"
      :visible="tacticsFreezePropsObj.visible"
      @close="CancelTacticsFreezeDialog()"
    >
      <el-alert
        type="warning"
        show-icon
        title="支付冻结、出款暂扣 差异注意！"
        description="支付失败冻结没有扣积分，出款暂扣是真扣了积分，所以积分余额是扣除了出款暂扣！"
      /><br />
      <el-select
        style="width: 130px"
        placeholder="全部信息"
        v-model="tacticsFreezePageQuery.freezeType"
        size="small"
        clearable
      >
        <el-option label="支付失败冻结" value="1"></el-option>
        <el-option label="出款审核暂扣" value="2"></el-option>
        <el-option label="常态支付失败冻结" value="3"></el-option>
        <el-option label="常态提现失败冻结" value="4"></el-option>
      </el-select>
      <el-input
        style="width: 200px"
        size="small"
        clearable
        placeholder="代理用户名"
        v-model.trim="tacticsFreezePageQuery.agentUsername"
      />
      <el-input
        style="width: 200px"
        size="small"
        clearable
        placeholder="商户订单号"
        v-model.trim="tacticsFreezePageQuery.appOrderId"
      />
      <el-input
        style="width: 220px"
        size="small"
        clearable
        placeholder="平台订单号"
        v-model.trim="tacticsFreezePageQuery.platformOrderId"
      />
      <el-input
        style="width: 100px"
        size="small"
        clearable
        placeholder="订单金额"
        v-model.trim="tacticsFreezePageQuery.orderAmount"
      />
      <el-input
        style="width: 100px"
        size="small"
        clearable
        placeholder="冻结金额"
        v-model.trim="tacticsFreezePageQuery.amount"
      />
      <el-input
        style="width: 220px"
        size="small"
        clearable
        placeholder="用户名"
        v-model.trim="tacticsFreezePageQuery.username"
      />
      <el-checkbox
        size="small"
        style="margin: 0 10px"
        border
        v-model="tacticsFreezePageQuery.nonExpired"
      >
        仅搜未逾期冻结
      </el-checkbox>
      <el-button
        icon="el-icon-search"
        type="primary"
        size="small"
        :loading="tacticsFreezeTableLoading"
        @click="
          tacticsFreezePageQuery.pageNum = 1;
          HandleTacticsFreeze();
        "
      />
      <div class="table-container">
        <el-table
          border
          stripe
          ref="tacticsFreezeTable"
          v-loading="tacticsFreezeTableLoading"
          element-loading-background="rgba(255, 255, 255, 0.8)"
          element-loading-spinner="el-icon-loading"
          :data="tacticsFreezeList"
        >
          <el-table-column align="center" width="110px" label="原因">
            <template slot-scope="scope">
              <el-tag size="mini" v-if="scope.row.freezeType === 1"
                >支付失败冻结</el-tag
              >
              <el-tag
                size="mini"
                type="success"
                v-else-if="scope.row.freezeType === 2"
                >出款审核暂扣</el-tag
              >
              <el-tag size="mini" v-else-if="scope.row.freezeType === 3"
                >常态支付失败冻结</el-tag
              >
              <el-tag size="mini" v-else-if="scope.row.freezeType === 4"
                >常态提现失败冻结</el-tag
              >
            </template>
          </el-table-column>
          <el-table-column align="center" min-width="260px" label="用户">
            <template slot-scope="scope">
              <el-tooltip
                effect="dark"
                content="scope.row.username"
                placement="top-start"
                popper-class="username-path-tooltip-class"
              >
                <div
                  slot="content"
                  v-html="formatUserNamePathTooltip(scope.row.usernamePath)"
                ></div>
                <el-button
                  size="mini"
                  @click="
                    CopyTextToClipboard(
                      formatPureUserNamePathTooltip(scope.row.usernamePath)
                    )
                  "
                >
                  {{
                    scope.row.usernamePath
                      ? scope.row.usernamePath.split("/")[
                          scope.row.usernamePath.split("/").length - 2
                        ]
                      : ""
                  }}
                  <i class="el-icon-document-copy"></i
                ></el-button>
              </el-tooltip>
              <span style="margin-left: 3px">{{ scope.row.username }}</span>
            </template>
          </el-table-column>
          <el-table-column width="200px" prop="appOrderId" label="商户订单号">
          </el-table-column>
          <el-table-column
            width="200px"
            prop="platformOrderId"
            label="平台订单号"
          >
          </el-table-column>
          <el-table-column width="80px" label="订单金额">
            <template slot-scope="scope">
              {{
                formatNumberWithCommasAndDecimalSeparator(
                  scope.row.orderAmount,
                  2
                )
              }}
            </template>
          </el-table-column>
          <el-table-column width="80px" label="冻结金额">
            <template slot-scope="scope">
              {{
                formatNumberWithCommasAndDecimalSeparator(scope.row.amount, 2)
              }}
            </template>
          </el-table-column>
          <el-table-column min-width="160px" label="备注">
            <template slot-scope="scope">
              <el-popover placement="top" width="350" trigger="hover">
                <div>{{ scope.row.remark }}</div>
                <span class="read-more" slot="reference">{{
                  scope.row.remark
                }}</span>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column align="center" width="153px" label="过期时间">
            <template slot-scope="scope">
              <span v-if="scope.row.expiredTime">{{
                scope.row.expiredTime
              }}</span>
              <el-tag v-else-if="scope.row.freezeType === 1">永冻积分</el-tag>
              <el-tag type="success" v-else-if="scope.row.freezeType === 2"
                >永扣积分</el-tag
              >
            </template>
          </el-table-column>
          <el-table-column :fixed="checkFixed" width="300" label="操作">
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.freezeType === 2"
                style="margin: 2px auto"
                plain
                size="mini"
                @click="arbitrateDetail(scope.row)"
              >
                审核详情
              </el-button>
              <!-- 冻 -->
              <template v-if="scope.row.freezeType === 1">
                <el-button
                  style="margin: 2px auto"
                  plain
                  icon="el-icon-ice-cream-square"
                  size="mini"
                  v-if="scope.row.expiredTime !== null"
                  type="primary"
                  @click="FreezeAmountForever(scope.row)"
                >
                  <span>暂冻改永冻</span>
                </el-button>
              </template>
              <!-- 扣 -->
              <template v-else-if="scope.row.freezeType === 2">
                <el-button
                  style="margin: 2px auto"
                  plain
                  icon="el-icon-ice-cream-square"
                  size="mini"
                  v-if="[0, 2].indexOf(scope.row.status) !== -1"
                  type="warning"
                  :disabled="true"
                  @click="FreezeAmountForever(scope.row)"
                >
                  <span v-if="scope.row.status === 0">正在暂扣中...</span>
                  <span v-else-if="scope.row.status === 2">正在解扣中...</span>
                </el-button>
                <el-button
                  style="margin: 2px auto"
                  plain
                  icon="el-icon-ice-cream-square"
                  size="mini"
                  v-else-if="
                    scope.row.status === 1 && scope.row.expiredTime !== null
                  "
                  type="success"
                  @click="FreezeAmountForever(scope.row)"
                >
                  <span>暂扣改永扣</span>
                </el-button>
              </template>

              <el-button
                style="margin: 2px auto"
                plain
                icon="el-icon-delete"
                size="mini"
                type="danger"
                v-if="[0, 2].indexOf(scope.row.status) === -1"
                @click="DeleteTacticsFreezeDialog(scope.row)"
              >
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <pagination
          v-show="tacticsFreezeTotal > 0"
          :total="tacticsFreezeTotal"
          :page.sync="tacticsFreezePageQuery.pageNum"
          :limit.sync="tacticsFreezePageQuery.pageSize"
          @pagination="HandleTacticsFreeze()"
        />
      </div>
    </el-dialog>

    <!-- 仲裁、回单详情弹框 -->
    <CommonArbitrateOrderDetail
      :arbitrateOrderDetailObj.sync="receiptOrderDetailObj"
    />
  </div>
</template>

<script>
import mainCommon from "@/utils/mainCommon";
import varCommon from "@/utils/varCommon";
import Pagination from "@/views/components/Pagination";
import CommonArbitrateOrderDetail from "@/views/components/dialog/CommonArbitrateOrderDetail";
import {
  listOrderDispatchTacticsFreeze,
  delFreezeAmount,
  freezeAmountForever,
  arbitrateWithdrawList,
} from "@/api/order";

export default {
  mixins: [mainCommon],
  props: ["tacticsFreezePropsObj"],
  watch: {
    tacticsFreezePropsObj(row) {
      if (row.visible) {
        this.tacticsFreezePageQuery.username =
          this.tacticsFreezePropsObj.username;
        this.HandleTacticsFreeze();
      }
    },
  },
  components: {
    Pagination,
    CommonArbitrateOrderDetail,
  },
  data() {
    return {
      tacticsFreezeTableLoading: false,
      tacticsFreezeList: [],
      tacticsFreezeTotal: 0,
      tacticsFreezePageQuery: {
        pageSize: 10,
        pageNum: 1,
        freezeType: null,
        agentUsername: null,
        username: null,
        nonExpired: true,
        appOrderId: null,
        platformOrderId: null,
        orderAmount: null,
        amount: null,
      },
      receiptOrderDetailObj: {}, // 回单订单详情数据
    };
  },
  methods: {
    // 冻结积分弹框
    HandleTacticsFreeze() {
      this.tacticsFreezeTableLoading = true;
      listOrderDispatchTacticsFreeze(
        this.ObjectClean(this.tacticsFreezePageQuery)
      )
        .then((res) => {
          this.tacticsFreezeList = res.data.list;
          this.tacticsFreezeTotal = res.data.total;
        })
        .finally(() => {
          this.tacticsFreezeTableLoading = false;
        });
    },
    // 关闭冻结积分弹框
    CancelTacticsFreezeDialog() {
      this.$emit("update:tactics-freeze-props-obj", {
        visible: false,
        username: null,
      });
      this.tacticsFreezeTotal = 0;
      this.tacticsFreezePageQuery = {
        pageSize: 10,
        pageNum: 1,
        freezeType: null,
        agentUsername: null,
        username: null,
        nonExpired: true,
        appOrderId: null,
        platformOrderId: null,
        orderAmount: null,
        amount: null,
      };
    },
    // 删除冻结积分
    DeleteTacticsFreezeDialog(row) {
      this.$confirm(
        `确定要把 ID「${row.id ? row.id : ""}」解除 ${
          row.amount
            ? this.formatNumberWithCommasAndDecimalSeparator(row.amount, 2)
            : ""
        } 积分？`,
        varCommon.message.warning,
        {
          confirmButtonText: varCommon.message.confirm,
          cancelButtonText: varCommon.message.cancel,
          type: "error",
        }
      )
        .then(() => {
          delFreezeAmount(row.id).then((res) => {
            this.$notify.success(res.message);
            this.HandleTacticsFreeze();
          });
        })
        .catch(() => {});
    },
    // 永远冻结积分
    FreezeAmountForever(row) {
      this.$confirm(
        `确定要把 ID「${row.id ? row.id : ""}」永远冻结 ${
          row.amount
            ? this.formatNumberWithCommasAndDecimalSeparator(row.amount, 2)
            : ""
        } 积分？`,
        varCommon.message.warning,
        {
          confirmButtonText: varCommon.message.confirm,
          cancelButtonText: varCommon.message.cancel,
          type: "error",
        }
      )
        .then(() => {
          freezeAmountForever(row.id).then((res) => {
            this.$notify.success(res.message);
            this.HandleTacticsFreeze();
          });
        })
        .catch(() => {});
    },
    // 仲裁/回单订单详情
    arbitrateDetail(row) {
      arbitrateWithdrawList({ id: row.withdrawArbitrationApplyId })
        .then((res) => {
          // 回单
          this.receiptOrderDetailObj = res.data.list[0];
          this.receiptOrderDetailObj.type = "withdraw";
          this.receiptOrderDetailObj.visible = true;
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
#tacticsFreezeDialog /deep/ .el-table td {
  padding: 2px 0;
}
#tacticsFreezeDialog {
  width: 80vw;
  margin: 0 auto;
  min-width: 1200px;
  height: 96vh;
  /deep/ .el-dialog {
    width: 100%;
  }
}
.read-more {
  width: 290px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>


// WEBPACK FOOTER //
// src/views/components/dialog/FreezeJifen.vue